import React from 'react';

import { Circle, Text, Wrapper } from './ProgressMarker-styled-components';

interface ProgressMarkerProps {
  isHighlighted: boolean;
  stepName: string;
  stepNumber: number;
}

// Marker is active when the associated step is current or completed
export const ProgressMarker = ({ isHighlighted, stepName, stepNumber }: ProgressMarkerProps) => (
  <Wrapper>
    <Circle $isHighlighted={isHighlighted}>
      {stepNumber}
    </Circle>
    <Text $isHighlighted={isHighlighted}>{stepName}</Text>
  </Wrapper>
);